import { reportError } from '../../../../services/errorReporting';

export function reportApprovalActionFailure(
    source: string,
    action: string,
    patientId: string,
    message: string,
    err: unknown,
    metadata?: Record<string, unknown>
): void {
    reportError({
        source,
        message,
        stack: err instanceof Error ? err.stack : undefined,
        url: globalThis.location?.href ?? '',
        userAgent: navigator.userAgent,
        errorType: 'workflow_action_failure',
        metadata: { caseId: patientId, action, ...metadata }
    });
}
